<template>
    <el-dialog :title="type == '题库' ? '单元测试' : '资源预览'" :close-on-click-modal="false" :visible.sync="dialogVisible"
        @close="close" :width="type=='仿真软件'?'80%':'120rem'">
        <div class="center-box" :class="{'big-screen': isShowBigScreen && !['文档','ppt','题库'].includes(type)}" :style="`height: ${type == '题库' ? 'auto' : 70}rem;`" v-if="dialogVisible">
            <i class="iconfont icon-quanping qp" @click="enterFullscreen" v-if="['文档','视频','图片','仿真软件','模型','动画'].includes(type) && !isShowBigScreen"></i>
            <i class="iconfont icon-tuichuquanping qp" @click="exitFullscreen" v-if="['文档','视频','图片','仿真软件','模型','动画'].includes(type) && isShowBigScreen"></i>
            <video id="audiox" class="center-item" v-if="type == '视频' && dialogVisible" controls></video>
            <iframe :key="previewUrl" class="center-item" :src="$severUrl(previewUrl)"
                :class="{ 'document-active': isShowBigScreen }" v-else-if="['文档'].includes(type)"
                style="width: 100%;height: 70rem;" frameborder="0"></iframe>
            <iframe :key="previewUrl + ''" class="center-item" :src="previewUrl" v-else-if="['仿真软件'].includes(type)"
                style="width: 100%;height: 70rem;" frameborder="0"></iframe>
            <div class="ppt-container" style="width: 100%;height: 100%;background-color: #F0F1F5;position: relative;"
                v-else-if="type == 'ppt' && pptList.length > 0">
                <i class="iconfont icon-shangyiyehoutuifanhui-yuankuang left" @click="changePpt('last')"></i>
                <i class="iconfont icon-xiayiyeqianjinchakangengduo-yuankuang right" @click="changePpt('next')"></i>
                <img class="img-ppt" v-if="pptList[pptIndex]" :src="$severUrl(pptList[pptIndex].filePreviewUrl)" alt="">
                <div class="ppt-bottom">
                    <p>
                        <i class="iconfont icon-shangyiye" @click="changePpt('last')"
                            style="margin-right: 1rem;"></i>第<span>{{ pptIndex + 1
                            }}</span>张幻灯片，共<span>{{ pptList.length }}</span>张<i class="iconfont icon-xiayiye"
                            @click="changePpt('next')" style="margin-left: 1rem;"></i>
                    </p>
                    <i class="iconfont icon-quanping quanping" @click="openBig"></i>
                </div>
            </div>
            <div v-else-if="['模型'].includes(type)&& previewUrl">
                <div v-if="suffix == 'fbx'" style="height: 70rem;width: 100%;" ref="fbx_model"></div>
                <!-- <model-fbx v-if="suffix == 'fbx'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-fbx> -->
                <model-obj v-else-if="suffix == 'obj'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-obj>
                <model-gltf v-else-if="suffix == 'gltf'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-gltf>
                <model-stl v-else-if="suffix == 'stl'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-stl>
                <model-collada v-else-if="suffix == 'collada'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-collada>
                <model-ply v-else-if="suffix == 'ply'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-ply>
                <model-three v-else-if="suffix == 'three'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-three>
            </div>
            <div v-else-if="type == '动画'" style="width: 100%;height: 100%;" ref="carton"></div>
            <div v-else-if="type == '图片'" class="img-container"
                style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;overflow: hidden;">
                <img class="img-box" style="max-width: 100%;max-height: 100%;object-fit: cover;" v-if="previewUrl"
                    :src="$severUrl(previewUrl)" alt="">
            </div>
            <div v-else-if="type == '题库'" style="width: 100%;height: 100%;">
                <div class="sub-top">
                    <div>{{ `[${subDetail.questionType || ''}]` }}</div>
                    <div v-html="subDetail.questionStem" class="sub-box-content" style="white-space: var(--lineWrap);"></div>
                </div>
                <el-radio-group v-model="subDetail.value" :disabled="subDetail.flag"
                    v-if="['判断题', '单选题'].includes(subDetail.questionType)">
                    <el-radio v-for="(item, index) in subDetail.questionOptionVOS" :label="item.id" :key="index">
                        <p style="margin-right: 0.5rem;">{{ alphabet[index] }}</p>
                        <p v-html="item.content"></p>
                    </el-radio>
                </el-radio-group>
                <el-checkbox-group v-model="subDetail.value" :disabled="subDetail.flag"
                    v-else-if="subDetail.questionType == '多选题'">
                    <el-checkbox v-for="(e, i) in subDetail.questionOptionVOS" :key="i" :label="e.id">
                        <div style="display: flex;">
                            <div>{{ alphabet[i] + '.' }}</div>
                            <div v-html="e.content" style="white-space: var(--lineWrap);"></div>
                        </div>
                    </el-checkbox>
                </el-checkbox-group>
                <div v-else-if="subDetail.questionType == '填空题'">
                    <div v-for="(e, i) in subDetail.questionOptionVOS" :key="i"
                        style="display: flex;margin-top: 2rem;align-items: center;">
                        <div>{{ alphabet[i] + '：' }}</div>
                        <el-input v-model="e.value" :disabled="subDetail.flag" style="width: 10rem;"></el-input>
                    </div>
                </div>
                <div v-if="subDetail.flag">
                    <div class="el-row">
                        <p>您的答案：</p>
                        <div class="yourself">
                            <p v-for="(item, index) in filterAnswerOptions(subDetail, 'userAnswer')" :key="index">{{ item
                                }}</p>
                        </div>
                    </div>
                    <div class="el-row">
                        <p>正确答案：</p>
                        <div class="correct">
                            <p v-for="(item, index) in filterAnswerOptions(subDetail, 'correctAnswer')" :key="index">{{
                                item }}</p>
                        </div>
                    </div>
                    <div class="el-row">
                        <p style="white-space: nowrap;">题目解析：</p>
                        <p v-html="subDetail.content"></p>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" v-if="type == '题库'">
            <el-button @click="dialogVisible = false">关闭</el-button>
            <el-button type="primary" v-if="openCourseId && !subDetail.flag" style="margin-left: 3rem;"
                @click="save">提交</el-button>
        </div>
        <div class="big-preview-box" v-if="isShowBigScreen && type == 'ppt'">
            <i class="iconfont icon-tuichuquanping big-exit" @click="exitBigScreen"></i>
            <i class="iconfont icon-shangyiyehoutuifanhui-yuankuang big-left" @click="changePpt('last')"></i>
            <i class="iconfont icon-xiayiyeqianjinchakangengduo-yuankuang big-right" @click="changePpt('next')"></i>
            <img :src="$severUrl(pptList[pptIndex].filePreviewUrl)" alt="">
        </div>
    </el-dialog>
</template>

<script>
import { ModelFbx, ModelObj, ModelGltf, ModelStl, ModelCollada, ModelPly, ModelThree } from "vue-3d-model";
import { scrollScale } from '@/utils/utils';
import { ResourcePreview } from '@/api/resourceMag';
import { QueryCopySoftwareDetail } from '@/api/software';
import * as THREE from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { numberToChinese,openVirtual } from '@/utils/utils';
import { SubmitQuestion, GetQuestionData, GetUserQuestion } from '@/api/subject';
import Hls from 'hls.js';
export default {
    components: { ModelFbx, ModelObj, ModelGltf, ModelStl, ModelCollada, ModelPly, ModelThree },
    data() {
        return {
            dialogVisible: false,
            /**是否打开ppt全屏预览 */
            isShowBigScreen: false,
            /**模型后缀 */
            suffix: '',
            type: '',
            alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            previewUrl: '',
            pptList: [],
            scene: null,
            camera: null,
            fbx: null,
            renderer: null,
            controls: null,
            mixer: null,
            pptIndex: 0,
            /**题库数据 */
            subDetail: {},
            lights: [
                {
                    type: "HemisphereLight",
                    position: { x: 0, y: 1, z: 0 },
                    skyColor: 0xffffff,
                    // groundColor: 0xFF0000, 此代码为灯光后颜色
                    intensity: 1
                },
                {
                    type: "DirectionalLight",
                    position: { x: 1, y: 1, z: -10 },
                    skyColor: 0xffffff,
                    // groundColor: 0xff0000, //此代码为灯光后颜色
                    intensity: 0.8
                },
                {
                    type: "DirectionalLight",
                    position: { x: 1, y: 1, z: 1 },
                    color: 0xffffff,
                    intensity: 0.8
                }
            ],
            /**已答题目数据 */
            hasAnswerList: [],
            /**资源id */
            resId: ''
        }
    },
    computed: {
        openCourseId() {
            return this.$route.query.openCourseId || '';
        },
    },
    methods: {
        numberToChinese,
        showDocumentBig() {
            this.isShowBigScreen = true;
        },
        /**进入全屏 */
        enterFullscreen() {
            this.isShowBigScreen = true;
            if (['模型', '动画'].includes(this.type)) {
                this.$nextTick(() => this.resizeRenderer());
            }
        },
        /**退出全屏 */
        exitFullscreen() {
            this.isShowBigScreen = false;
            if (['模型', '动画'].includes(this.type)) {
                this.$nextTick(() => this.resizeRenderer());
            }
        },
        /**全屏切换时重新调整 Three.js 渲染尺寸 */
        resizeRenderer() {
            const container = this.type == '动画' ? this.$refs.carton : this.$refs.fbx_model;
            if (!container || !this.renderer) return;
            const width = container.clientWidth;
            const height = container.clientHeight;
            if (width === 0 || height === 0) return;
            this.renderer.setSize(width, height);
            this.camera.aspect = width / height;
            this.camera.updateProjectionMatrix();
            if (this.controls) {
                this.controls.update();
            }
        },
        autoScaleModel(model, targetSize = 2) {
            // 计算模型的包围盒
            const bbox = new THREE.Box3().setFromObject(model);
            const size = bbox.getSize(new THREE.Vector3());
            
            // 获取最大尺寸
            const maxDim = Math.max(size.x, size.y, size.z);
            
            // 计算缩放比例
            const scale = targetSize / maxDim;
            
            // 应用缩放
            model.scale.set(scale, scale, scale);
            
            console.log(`模型尺寸: ${maxDim.toFixed(2)}, 缩放比例: ${scale.toFixed(2)}`);
            return scale;
        },
        handleFbx(){
            this.removeCanvas(); // 确保旧资源被彻底清理
            const width = this.$refs.fbx_model.clientWidth;
            const height = this.$refs.fbx_model.clientHeight;

            // 初始化 Three.js 场景
            this.scene = new THREE.Scene();
            this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
            this.renderer = new THREE.WebGLRenderer({ antialias: true }); // 启用抗锯齿
            this.renderer.setSize(width, height);
            this.$refs.fbx_model.appendChild(this.renderer.domElement);
            this.renderer.setClearColor('#ffffff');
            // 设置相机位置和背景
            this.camera.position.set(0, 0, 0.4);
            this.camera.lookAt(0, 0, 0);
            // this.scene.background = new THREE.Color(0xffffff);
            // // 添加地面网格
            // const gridHelper = new THREE.GridHelper(20, 20, 0x444444, 0x222222);
            // this.scene.add(gridHelper);

            // // 添加坐标轴
            // const axesHelper = new THREE.AxesHelper(5);
            // this.scene.add(axesHelper);
            // this.scene.background = new THREE.Color(0x336688);

            // 添加光源
            const ambientLight = new THREE.AmbientLight(0xffffff, 10); // 调整环境光强度
            const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight.position.set(2, 3, 4);
            directionalLight.castShadow = true;
            this.renderer.shadowMap.enabled = true;
            this.scene.add(ambientLight, directionalLight);

            // 添加相机控制器
            this.controls = new OrbitControls(this.camera, this.renderer.domElement);
            this.controls.enableDamping = true;

            // 加载 FBX 模型
            this.loader = new FBXLoader();
            this.loader.load(
                this.$severUrl(this.previewUrl),
                (fbx) => {
                    try {
                        this.fbx = fbx;
                        this.autoScaleModel(fbx,0.5); // 根据模型大小调整
                        this.scene.add(fbx);
                        const box = new THREE.Box3().setFromObject(fbx);
                        const size = box.getSize(new THREE.Vector3()).length();
                        const center = box.getCenter(new THREE.Vector3());

                        this.camera.position.copy(center);
                        this.camera.position.z += size * 1.2;
                        this.camera.lookAt(center);
                        fbx.traverse((child) => {
                            if (child.isMesh) {
                                child.castShadow = true;
                                child.material.metalness = 0.58;
                                child.material.emissiveMap = child.material.map;
                            }
                        });

                        this.mixer = new THREE.AnimationMixer(fbx);
                        if (fbx.animations.length > 0) {
                            const idleAction = this.mixer.clipAction(fbx.animations[0]);
                            idleAction.play();
                        }
                        this.animate(); // 启动动画循环
                    } catch (error) {
                        console.error('动画加载失败:', error);
                    }
                },
                undefined,
                (error) => {
                    console.error('动画加载错误:', error);
                }
            );
        },
        /** 展示动画 */
        handleCarton() {
            this.removeCanvas(); // 确保旧资源被彻底清理
            const width = this.$refs.carton.clientWidth;
            const height = this.$refs.carton.clientHeight;

            // 初始化 Three.js 场景
            this.scene = new THREE.Scene();
            this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
            this.renderer = new THREE.WebGLRenderer({ antialias: true }); // 启用抗锯齿
            this.renderer.setSize(width, height);
            this.$refs.carton.appendChild(this.renderer.domElement);

            // 设置相机位置和背景
            this.camera.position.set(0, 0, 0.4);
            this.camera.lookAt(0, 0, 0);
            // this.scene.background = new THREE.Color(0xffffff);
            // 添加地面网格
            const gridHelper = new THREE.GridHelper(20, 20, 0x444444, 0x222222);
            this.scene.add(gridHelper);

            // 添加坐标轴
            const axesHelper = new THREE.AxesHelper(5);
            this.scene.add(axesHelper);
            this.scene.background = new THREE.Color(0x336688);

            // 添加光源
            const ambientLight = new THREE.AmbientLight(0xffffff, 10); // 调整环境光强度
            const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight.position.set(2, 3, 4);
            directionalLight.castShadow = true;
            this.renderer.shadowMap.enabled = true;
            this.scene.add(ambientLight, directionalLight);

            // 添加相机控制器
            this.controls = new OrbitControls(this.camera, this.renderer.domElement);
            this.controls.enableDamping = true;

            // 加载 FBX 模型
            this.loader = new FBXLoader();
            this.loader.load(
                this.$severUrl(this.previewUrl),
                (fbx) => {
                    try {
                        this.fbx = fbx;
                        fbx.scale.set(0.001, 0.001, 0.001); // 根据模型大小调整
                        this.scene.add(fbx);

                        fbx.traverse((child) => {
                            if (child.isMesh) {
                                child.castShadow = true;
                                child.material.metalness = 0.58;
                                child.material.emissiveMap = child.material.map;
                            }
                        });

                        this.mixer = new THREE.AnimationMixer(fbx);
                        if (fbx.animations.length > 0) {
                            const idleAction = this.mixer.clipAction(fbx.animations[0]);
                            idleAction.play();
                        }
                        this.animate(); // 启动动画循环
                    } catch (error) {
                        console.error('动画加载失败:', error);
                    }
                },
                undefined,
                (error) => {
                    console.error('动画加载错误:', error);
                }
            );
        },

        // 动画循环
        animate() {
            if(!this.dialogVisible)return;
            requestAnimationFrame(() => this.animate()); // 节流机制
            if (this.mixer) {
                this.mixer.update(0.016); // 控制帧率
            }
            this.renderer.render(this.scene, this.camera);
        },
        /**打开全屏 */
        openBig() {
            this.isShowBigScreen = true;
        },
        /**关闭ppt全屏 */
        exitBigScreen() {
            this.isShowBigScreen = false;
        },
        /**过滤答案选项 */
        filterAnswerOptions(data, type) {
            if (!data.questionType) return;
            var answerArr = [];
            if (data.questionType == '填空题') {
                return data[type]
            } else {
                var obj = {};
                data.questionOptionVOS.forEach((item) => {
                    obj[item.id] = item;
                })
                if (['单选题'].includes(data.questionType)) {
                    if (data[type] && data[type].length > 0) {
                        answerArr = [obj[data[type][0]] ? this.alphabet[obj[data[type][0]].orderIndex - 1] : ''];
                    }
                } else if (data.questionType == '多选题') {
                    data[type].forEach(item => {
                        answerArr.push(this.alphabet[obj[item].orderIndex - 1]);
                    })
                } else if (data.questionType == '判断题') {
                    answerArr = [obj[data[type]] ? obj[data[type]].content : ''];
                }
            }
            return answerArr;
        },
        /**弹窗关闭 */
        close() {
            this.isShowBigScreen = false;
            this.previewUrl = '';
            this.type = '';
            this.pptIndex = 0;
            this.removeCanvas();
        },
        /**移除画布 */
        removeCanvas() {
            const dom = this.$refs.carton;
            const canvas = this.renderer ? this.renderer.domElement : null;
            if (dom && canvas) {
                let children = dom.children;
                if (children && children.length > 0) {
                    dom.removeChild(canvas);
                }
            }
        },
        /**m3u8视频播放 */
        playVideo(previewUrl) {
            const audio = document.getElementById("audiox");
            if(!audio)return;
            const hls = new Hls();
            if (Hls.isSupported()) {
                hls.loadSource(previewUrl);
                hls.attachMedia(audio);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    audio.play();
                });
            } else if (audio.canPlayType("application/vnd.apple.mpegurl")) {
                audio.src = previewUrl;
                audio.addEventListener("canplay", function () {
                    audio.play();
                });
            } else {
                console.error("HLS is not supported in this browser");
            }
        },
        save() {
            var obj = {};
            obj.questionId = this.subDetail.questionId;
            if (this.subDetail.questionType == '多选题') {
                obj.answer = this.subDetail.value;
            } else if (['单选题', '判断题'].includes(this.subDetail.questionType)) {
                obj.answer = this.subDetail.value ? [this.subDetail.value] : [];
            } else if (this.subDetail.questionType == '填空题') {
                obj.answer = this.subDetail.questionOptionVOS.map(el => el.value)
            }
            var params = {};
            params.userQuestionAnswerPOS = [obj];
            var teachingUnitId = localStorage.getItem('currentId');
            params.businessId = this.openCourseId + '-' + teachingUnitId;
            params.questionSource = 'course_test_question';
            SubmitQuestion(params).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getUserQuestion();
                }
            })
        },
        /**获取答题详情 */
        getUserQuestion(id, callback) {
            var teachingUnitId = localStorage.getItem('currentId');
            var params = {
                "businessId": this.openCourseId + '-' + teachingUnitId,
                "questionIds": [id || this.resId],
                "questionSource": "course_test_question"
            }
            GetUserQuestion(params).then(res => {
                if (res.code == 200) {
                    this.hasAnswerList = res.data;
                    this.queryDetail(id, callback);
                }
            })
        },
        /**ppt翻页 */
        changePpt(type) {
            if (type == 'next') {
                if (this.pptIndex == this.pptList.length - 1) {
                    this.$msg({
                        showClose: true,
                        message: "已经是最后一页啦",
                        type: "warning",
                    });
                    return;
                }
                this.pptIndex++;
            } else {
                if (this.pptIndex == 0) {
                    this.$msg({
                        showClose: true,
                        message: "已经是第一页啦",
                        type: "warning",
                    });
                    return;
                }
                this.pptIndex--;
            }
        },
        modelLoading(xhr) {
            const loading = this.$loading({
                lock: true,
                text: "正在加载模型，请等待！",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
                customClass: "modelLoadingClass"
            });
            if (xhr.loaded == xhr.total) {
                loading.close();
            }
        },
        /**仿真软件参数拼接 */
        softwareStr(optSource, resId) {
            if (this.openCourseId) {
                return '?optSource=' + optSource + '&businessId=' + this.openCourseId + '-' + localStorage.getItem('currentId') + '-' + resId + '-' + this.$route.query.courseLearningSource;
            } else {
                return '?optSource=' + optSource + '&businessId=' + this.courseId;
            }
        },
        /**获取仿真软件详情 */
        querySoftwareDetail(id,callback) {
            QueryCopySoftwareDetail({ id }).then(res => {
                // var index = res.data.url.indexOf('https://');
                // if (index == -1) {
                //     this.previewUrl = (index == -1 ? 'https://' : '') + res.data.url;
                // }
                this.previewUrl = openVirtual(res.data.url) + this.softwareStr('teaching_unit_bind_drill', id);
                typeof callback == 'function' && callback();
            })
        },
        /**获取题目数据 */
        queryDetail(id, callback) {
            GetQuestionData({ ids: [id || this.resId] }).then(res => {
                if (res.code == 200) {
                    var data = res.data[0];
                    var questionId = this.hasAnswerList.length > 0 ? this.hasAnswerList[0].questionId : '';
                    if (data.questionId == questionId) {
                        var hasAnswer = this.hasAnswerList[0];
                        data.flag = true;
                        data.userAnswer = hasAnswer.userAnswer;
                        data.correctAnswer = hasAnswer.correctAnswer;
                    }
                    if (data.questionType == '多选题') {
                        data.value = [];
                    } else if (['单选题', '判断题'].includes(data.questionType)) {
                        data.value = '';
                    } else if (data.questionType == '填空题') {
                        data.questionOptionVOS.forEach(el => {
                            el.value = '';
                        })
                    }
                    this.subDetail = data;
                    typeof callback == 'function' && callback();
                }
            })
        },
        /**获取资源详情 */
        resourcePreview(id, callback) {
            var params = {
                id
            }
            ResourcePreview(params).then(res => {
                if (res.code == 200) {
                    this.detail = res.data;
                    var fileArr = res.data;
                    if (this.type == '视频') {
                        var index = fileArr.findIndex(item => item.orderIndex == -1);
                        if (index != -1) {
                            fileArr.splice(index, 1);
                        }
                        var el = fileArr.find(item => {
                            return item.fileName == 'index.m3u8'
                        })
                        if (el) {
                            setTimeout(() => {
                                this.playVideo(this.$severUrl(el.filePreviewUrl));
                            }, 100)
                        }
                    } else if (this.type == '文档') {
                        this.previewUrl = res.data;
                    } else if (this.type == 'ppt') {
                        var index = fileArr.findIndex(item => item.orderIndex == -1);
                        if (index != -1) {
                            fileArr.splice(index, 1);
                        }
                        this.pptList = fileArr;
                    } else if (['动画', '模型'].includes(this.type)) {
                        this.previewUrl = fileArr;
                        let arr = fileArr.split('.');
                        this.suffix = arr[arr.length - 1].toLowerCase();
                        if(this.type=='动画'){
                            this.$nextTick(() => {
                            let timer = setInterval(() => {
                                let dom = this.$refs.carton;
                                if (dom) {
                                    clearInterval(timer);
                                    this.handleCarton();
                                }
                            }, 100)
                        });   
                        }else if(this.suffix=='fbx'&&this.type=='模型'){
                            this.$nextTick(() => {
                            let timer = setInterval(() => {
                                let dom = this.$refs.fbx_model;
                                if (dom) {
                                    clearInterval(timer);
                                    this.handleFbx();
                                }
                            }, 100)
                        });   
                        }
                    } else if (this.type == '图片') {
                        this.previewUrl = res.data;
                        setTimeout(() => {
                            scrollScale('.img-container', '.img-box');
                        }, 100)
                    }
                }
                typeof callback == 'function' && callback();
            });
        },
        /**键盘左右键控制ppt翻页 */
        keyDown(e) {
            if (this.type != 'ppt') return;
            if (e.keyCode == 37) {
                this.changePpt('last');
            } else if (e.keyCode == 39) {
                this.changePpt('next');
            }
        },
    },
    mounted() {
        window.addEventListener('keydown', this.keyDown);
    },
    destroyed() {
        window.removeEventListener('keydown', this.keyDown);
    }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__title {
    font-weight: 700;
}

.document-active {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100% !important;
    z-index: 2000;
}

.qp {
    position: absolute;
    right: 2.8rem;
    top: -40px;
    cursor: pointer;
    z-index: 10;
}

/* 通用全屏模式：将预览内容铺满视口 */
.center-box.big-screen {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100% !important;
    z-index: 2000;
    background: #fff;
    margin: 0;
    padding: 0;
}

/* 全屏模式下调整按钮位置 */
.center-box.big-screen .qp {
    top: 1rem;
    right: 1rem;
}

.center-box.big-screen .center-item {
    height: 100% !important;
}

.center-box.big-screen .img-container {
    height: 100% !important;
}

.center-box.big-screen .img-box {
    max-width: 100%;
    max-height: 100%;
}

.center-box {
    position: relative;

    &> :nth-child(2) {
        height: 100%;
        width: 100%;
    }
}

.img-ppt {
    height: calc(100% - 2.4rem);
    width: 100%;
}

.ppt-bottom {
    height: 2.4rem;
    background-color: #444444;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    font-size: 12px;
    align-items: center;
    position: relative;

    &> :nth-child(1) {
        display: flex;
        align-items: center;
        position: relative;
    }

    .icon-quanping {
        position: absolute;
        right: 2rem !important;
        top: 50%;
        font-size: 16px;
        cursor: pointer;
    }

    i {
        cursor: pointer;
    }

    &> :nth-child(2) {
        position: absolute;
        top: calc(50% - 0.8rem);
        right: 7rem;
    }

    &> :nth-child(3) {
        position: absolute;
        top: calc(50% - 0.8rem);
        right: 2.5rem;
    }
}

.sub-top {
    display: flex;

    &> :nth-child(1) {
        font-weight: 700;
        margin-right: 1rem;
    }
}

/deep/.el-radio-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-radio {
    margin-top: 1rem;
    display: flex;
}

/deep/.el-radio__label {
    display: flex;
    white-space: var(--lineWrap);
}

/deep/.el-checkbox-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-checkbox {
    margin-top: 2rem;
}

/deep/.el-input__inner {
    border: 1px solid transparent;
    border-bottom: 2px solid #334681;
    border-radius: 0;
}

.img-ppt {
    width: 100%;
    height: 67.5rem;
}

.dialog-footer {
    display: flex;
    justify-content: center;
}

.el-row {
    display: flex;
    margin-top: 1rem;
    white-space: var(--lineWrap);
}

.yourself {
    display: flex;
    color: var(--blue);
}

.correct {
    display: flex;
    color: #67c23a;
}

.img-box {
    transition: all 0.3s;
}

/deep/.el-dialog__body {
    padding-top: 1rem !important;
}

.left {
    position: absolute;
    top: 50%;
    left: 0;
    font-size: 5rem;
    transform: translateY(-50%);
    color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    display: none;
}

.right {
    position: absolute;
    top: 50%;
    right: 0;
    font-size: 5rem;
    transform: translateY(-50%);
    color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    display: none;
}

.ppt-container:hover>.left {
    display: block !important;
}

.ppt-container:hover>.right {
    display: block !important;
}

.big-preview-box {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    img {
        width: 100%;
        height: 100%;
    }

    .big-left {
        position: absolute;
        top: 50%;
        left: 3rem;
        transform: translateY(-50%);
        z-index: 9999;
        font-size: 5rem;
        color: rgba(0, 0, 0, 0.6);
        cursor: pointer;
    }

    .big-right {
        position: absolute;
        top: 50%;
        right: 3rem;
        transform: translateY(-50%);
        z-index: 9999;
        font-size: 5rem;
        color: rgba(0, 0, 0, 0.6);
        cursor: pointer;
    }

    .big-exit {
        position: absolute;
        top: 2rem;
        right: 3rem;
        z-index: 9999;
        font-size: 3rem;
        color: rgba(255, 255, 255, 0.9);
        cursor: pointer;
        transition: color 0.2s;
    }
    .big-exit:hover {
        color: #ffffff;
    }
}

/deep/.el-dialog {
    border-radius: 1rem;
}

.center-item {
    width: 100%;
    height: 100%;
}

.sub-box-content {
    img {
        max-height: 30rem !important;
        max-width: 30rem !important;
        width: auto !important;
        height: auto !important;
        object-fit: cover;
    }
}
@media screen and (max-width:750px){
    /deep/.el-dialog{
        width: 58rem !important;
    }
}
</style>